import React, { useRef, useEffect, useState } from "react";
import InputOtp from "../../common/inputfield/input";
import { Button, Input, Modal } from "antd";
import { frogetPassword } from "../../service/api";
import { useMutation } from "@tanstack/react-query";
import { LoadingOutlined, SendOutlined } from "@ant-design/icons";
const ForgetCodeModal = ({ visible, closeHandler, setOpenModal }) => {
  const P1 = useRef();
  const P2 = useRef();
  const [loading, setLoading] = useState();
  const [OtpModal, setOtpModal] = useState(false);
  const [seconds, setSeconds] = useState(120);
  const [code, setCode] = useState({});
  const [phoneNumber, setPhoneNumber] = useState("");

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  //* phone number mutation
  const mutation = useMutation(frogetPassword, {
    onSuccess: () => {
      setOtpModal(true);
    },
    onError: () => {
      setOtpModal(true);
    },
  });
  //* otp number mutation
  const otpMutation = useMutation(frogetPassword, {
    onMutate: () => {
      setLoading(true);
    },
    onSuccess: () => {
      setOtpModal(false);
      setOpenModal(false);
    },
    onError: () => {
      setOtpModal(true);
      setOpenModal(true);
      setLoading(false);
    },
  });
  useEffect(() => {
    if ((seconds > 0) & OtpModal) {
      const interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [seconds, OtpModal]);

  const otpHandler = () => {
    otpMutation.mutate({
      phoneNumber: phoneNumber,
      otpCode: code?.otpCode,
    });
  };

  const submitHandler = () => {
    mutation.mutate({
      phoneNumber: phoneNumber,
    });
  };

  const retry = () => {
    setSeconds(120);
    P1.current.style.display = "none";
    P2.current.style.display = "block";
    setTimeout(() => {
      P2.current.style.display = "none";
      P1.current.style.display = "block";
    }, 120000);
  };
  return (
    <Modal
      closable={false}
      okButtonProps={{ hidden: true }}
      cancelButtonProps={{ hidden: true }}
      className="loginModal"
      bodyStyle={{ paddingInline: "none", margin: -35 }}
      onCancel={closeHandler}
      open={visible}
    >
      {OtpModal && mutation.isSuccess ? (
        <div className=" p-3 bg-[#005AC7] rounded-md ">
          <form className="    flex flex-col top-[0px]  right-0 w-full p-3 justify-center items-center border-dashed border-4   border-white rounded-xl gap-[32px] ">
            <p className="text-white text-xl max-sm:text-base max-sm:text-center">
              کد تایید به شماره {phoneNumber} ارسال گردید
            </p>
            <div className="flex flex-col gap-[10px] text-right text-white">
              <p dir="rtl">کد تایید:</p>

              <InputOtp
                setOpenModal={setOpenModal}
                phoneNumber={phoneNumber}
                submitHandler={otpHandler}
                code={code}
                setCode={setCode}
              />
            </div>
            <Button
              disabled={loading ? true : false}
              onClick={otpHandler}
              className="text-white items-center"
              icon={loading ? <LoadingOutlined /> : <SendOutlined />}
            >
              ارسال
            </Button>
            <button onClick={retry} type="button">
              <p
                onClick={submitHandler}
                className="text-[#FFFFFF] text-["
                ref={P1}
              >
                ارسال مجدد کد
              </p>
              <p className="hidden text-[#B3B3B3]" ref={P2}>
                ارسال مجدد کد پس از {minutes}:{remainingSeconds < 10 ? "0" : ""}
                {remainingSeconds}
              </p>
            </button>
          </form>
        </div>
      ) : (
        <section className=" p-3 flex flex-col h-full   rounded-md   bg-[#005AC7] backdrop-filter backdrop-blur-[14px]">
          <div className=" flex flex-col gap-8 border-2 border-dashed border-white p-3 rounded-lg">
            <p className="text-white text-center">
              برای بازیابی کد کارشناس ، لطفا شماره همراه خود را وارد کنید. کد
              کارشناس از طریق پیامک برای ایشان ارسال خواهد شد.
            </p>
            <Input
              className="text-2xl text-center w-[85%] m-auto"
              onChange={(input) => setPhoneNumber(input.target.value)}
              placeholder="شماره همراه"
              type="number"
              accept="number"
              pattern={/^((\+98|0)9\d{9})$/gm}
            />
            <Button
              icon={<SendOutlined />}
              loading={mutation.isLoading}
              onClick={() => submitHandler()}
              className="w-[50%] m-auto text-white bg-"
            >
              ارسال
            </Button>
          </div>
        </section>
      )}
    </Modal>
  );
};
export default ForgetCodeModal;
